import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " ID Versi ", -1)
const _hoisted_3 = { class: "my-1 font-normal" }
const _hoisted_4 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Nama Versi ", -1)
const _hoisted_6 = { class: "my-1 font-normal w-10/12" }
const _hoisted_7 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Total Leg ", -1)
const _hoisted_9 = { class: "my-1 font-normal w-8/12" }
const _hoisted_10 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Currency ", -1)
const _hoisted_12 = { class: "my-1 font-normal w-8/12" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_14 = { class: "py-3 space-y-6" }
const _hoisted_15 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Rate Periode ", -1)
const _hoisted_17 = { class: "my-1 font-normal" }
const _hoisted_18 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Berkas Lampiran ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_21 = { class: "py-3 space-y-6" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xl text-black-lp-300 font-semibold" }, " Riwayat Perubahan ", -1)
const _hoisted_23 = { class: "w-4/5" }
const _hoisted_24 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Status Versi ", -1)
const _hoisted_26 = { class: "my-1 font-normal" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "capitalize" }
const _hoisted_29 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_31 = { class: "my-1 font-normal" }
const _hoisted_32 = { class: "text-gray-lp-500" }
const _hoisted_33 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Terakhir Diubah ", -1)
const _hoisted_35 = { class: "my-1 font-normal" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_attachment = _resolveComponent("download-attachment")!
  const _component_TableV1 = _resolveComponent("TableV1")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getDetail,
    title: _ctx.detailData.rateVersionName
  }, _createSlots({
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", {
              class: ["rounded-full px-2 py-0 font-medium", _ctx.styleStatusBaseRates]
            }, [
              _createVNode("span", _hoisted_28, _toDisplayString(_ctx.detailData.rateVersionStatus
                    .toLowerCase()
                    .split("-")
                    .join(" ")), 1)
            ], 2)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_29, [
        _hoisted_30,
        _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formatDateToString(_ctx.detailData.rateVersionCreatedAt)), 1),
        _createVNode("div", _hoisted_32, _toDisplayString(_ctx.detailData.rateVersionCreatedBy), 1)
      ]),
      _createVNode("div", _hoisted_33, [
        _hoisted_34,
        _createVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDateToString(
              _ctx.detailData.rateVersiondUpdatedAt ||
                _ctx.detailData.rateVersionCreatedAt
            )), 1),
        _createVNode("div", _hoisted_36, _toDisplayString(_ctx.detailData.rateVersiondUpdatedBy), 1)
      ]),
      _createVNode("div", _hoisted_37, [
        (_ctx.isEditAble)
          ? (_openBlock(), _createBlock(_component_button_fill, {
              key: 0,
              title: "Edit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEdit())),
              class: "px-8 bg-red-lp-300"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (!_ctx.isLoading)
      ? {
          name: "data",
          fn: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailData.rateVersionId), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detailData.rateVersionName), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.detailData.rateVersionTotalRoute), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.convertWordingCurrency(_ctx.detailData.rateVersionCurrency)), 1)
            ]),
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.formatPeriode(
                _ctx.detailData.rateVersionStartDate,
                _ctx.detailData.rateVersionEndDate
              )), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_download_attachment, {
                  name: _ctx.detailData.rateVersionFiledUpload,
                  url: _ctx.detailData.rateVersionFiledUpload,
                  linked: true,
                  maxLength: 45
                }, null, 8, ["name", "url"])
              ])
            ]),
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_TableV1, {
                  columns: _ctx.columns,
                  data: _ctx.updateHistoryList
                }, null, 8, ["columns", "data"])
              ])
            ])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"]))
}